import { create } from "zustand"
import { persist, type PersistStorage } from "zustand/middleware"

// Note: This store is mainly for client-only preferences persisted across reloads.
interface ClientSetting {
  language: "vi" | "en"
  forceUseLanguage: boolean
  lastChangeTimestamp: number
  changeLanguage: (language: "vi" | "en", forceUseLanguage?: boolean) => void
  hasHydrated: boolean
  setHasHydrated: (value: boolean) => void
}

interface CreateClientSettingStoreParams {
  storage: PersistStorage<ClientSetting>
}

function createClientSettingStore({ storage }: CreateClientSettingStoreParams) {
  return create<ClientSetting, [["zustand/persist", ClientSetting]]>(
    persist(
      (set) => ({
        language: "vi",
        forceUseLanguage: false,
        lastChangeTimestamp: 0,
        changeLanguage(language, forceUseLanguage = true) {
          set({
            language,
            forceUseLanguage,
            lastChangeTimestamp: Date.now(),
          })
        },
        hasHydrated: false,
        setHasHydrated: (hasHydrated: boolean) => {
          set({ hasHydrated })
        },
      }),
      {
        name: "be-client-setting-2",
        storage,
        onRehydrateStorage: () => (state) => {
          state?.setHasHydrated(true)
        },
      }
    )
  )
}

export { createClientSettingStore }
export type { ClientSetting }
